import { AlertTriangle, ListMinus, X } from 'lucide-react';
import { useDeleteMainCategory } from '../hooks/useDeleteMainCategory';

export const DeleteConfirmModal = (props) => {
  const { isDeleteModalOpen, setIsDeleteModalOpen, category } = props;
  const { mutate: deleteMainCategory, isPending } = useDeleteMainCategory();

  const handleDelete = () => {
    // console.log(category);

    if (category?._id) {
      deleteMainCategory(category._id, {
        onSuccess: () => {
          setIsDeleteModalOpen(false);
        },
      });
    }
  };

  if (!isDeleteModalOpen || !category) return null;

  return (
    <div className='fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4'>
      <div className='bg-card border border-border rounded-lg w-full max-w-md'>
        {/* Header */}
        <div className='flex items-center justify-between px-6 py-4 border-b border-border'>
          <div className='flex items-center space-x-2'>
            <div className='p-2 bg-destructive/10 rounded-lg'>
              <AlertTriangle className='text-destructive' size={20} />
            </div>
            <h2 className='text-lg font-semibold'>Delete Category</h2>
          </div>
          <button
            onClick={() => setIsDeleteModalOpen(false)}
            className='p-1 hover:bg-muted rounded-md transition-colors'
          >
            <X size={20} />
          </button>
        </div>

        {/* Content */}
        <div className='px-6 py-4 space-y-4'>
          <p className='text-sm text-muted-foreground'>
            Are you sure you want to delete the category{' '}
            <span className='font-semibold text-foreground'>"{category?.name?.english}"</span>?
          </p>

          <div className='bg-destructive/10 border border-destructive/20 rounded-lg p-3'>
            <p className='text-xs text-destructive'>
              This action cannot be undone. This will permanently delete the category and may affect any subcategories
              or associated services.
            </p>
          </div>

          {category && (
            <div className='bg-muted rounded-lg p-3 space-y-1'>
              <div className='text-xs text-muted-foreground'>Category Details:</div>
              <div className='text-sm font-medium'>{category.name?.english}</div>
              <div className='text-xs text-muted-foreground'>Slug: {category.slug}</div>
              <div className='text-xs text-muted-foreground'>Level: {category.level}</div>
            </div>
          )}
        </div>

        {/* Actions */}
        <div className='flex justify-end space-x-3 px-6 py-4 border-t border-border'>
          <button
            onClick={() => setIsDeleteModalOpen(false)}
            disabled={isPending}
            className='px-4 py-2 text-sm border border-border rounded-md hover:bg-accent transition-colors disabled:opacity-50'
          >
            Cancel
          </button>
          <button
            onClick={handleDelete}
            disabled={isPending}
            className='px-4 py-2 text-sm bg-destructive text-destructive-foreground rounded-md hover:bg-destructive/90 transition-colors disabled:opacity-50'
          >
            {isPending ? (
              <div className='flex items-center justify-center'>
                <div className='animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2' />
                Deleting...
              </div>
            ) : (
              <div className='flex items-center justify-center'>
                <ListMinus size={16} className='mr-2' />
                Delete Category
              </div>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};
